import { render, staticRenderFns } from "./EditMateriasPlan.vue?vue&type=template&id=158e16ce&"
import script from "./EditMateriasPlan.vue?vue&type=script&lang=js&"
export * from "./EditMateriasPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports